module.exports = __webpack_public_path__ + "img/Cristine_Marquez_CV_ENG_page-0001.c3e6850b.jpg";